import React, { useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import Box from '@mui/material/Box';

import BackButton from '@ts-core/components/BackButton';

import { useActivityActions } from '../../hooks';
import ActivityForm from '../../components/ActivityForm';
import { ActivityInput } from '../../types/index';

interface CreateActivityPageRoue {
  courseId: string;
}

const CreateActivityPage = () => {
  const history = useHistory();
  const { courseId } = useParams<CreateActivityPageRoue>();

  const { onCreateActivity, createActivityError, createActivityLoading } = useActivityActions({ courseId });

  const handleGoBack = useCallback(() => {
    history.push(`/${courseId}/activities`);
  }, [history, courseId]);

  const handleCreateActivity = useCallback(
    (input: ActivityInput) => {
      onCreateActivity(input, handleGoBack);
    },
    [handleGoBack, onCreateActivity]
  );

  return (
    <>
      <BackButton onGoBack={handleGoBack} title="Crear Tarea" subtitle="Tareas" />
      <Box mt={2}>
        <ActivityForm submitting={createActivityLoading} submitError={createActivityError} onSubmit={handleCreateActivity} />
      </Box>
    </>
  );
};

export default CreateActivityPage;
